var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmenIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0H2.5C1.12167 0 0 1.1441 0 2.55V17H1.66667V14.45H18.3333V17H20V2.55C20 1.1441 18.8783 0 17.5 0ZM2.5 1.7H17.5C17.96 1.7 18.3333 2.08165 18.3333 2.55V9.35H16.6667V8.5C16.6667 7.0941 15.545 5.95 14.1667 5.95H11.6667C11.0267 5.95 10.4425 6.1965 10 6.6011C9.5575 6.1965 8.97333 5.95 8.33333 5.95H5.83333C4.455 5.95 3.33333 7.0941 3.33333 8.5V9.35H1.66667V2.55C1.66667 2.08165 2.04083 1.7 2.5 1.7ZM9.16667 9.35H5V8.5C5 8.03165 5.37417 7.65 5.83333 7.65H8.33333C8.7925 7.65 9.16667 8.03165 9.16667 8.5V9.35ZM10.8333 8.5C10.8333 8.03165 11.2067 7.65 11.6667 7.65H14.1667C14.6267 7.65 15 8.03165 15 8.5V9.35H10.8333V8.5ZM1.66667 12.75V11.05H18.3333V12.75H1.66667Z",
    fill: "#5C6C68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmenIcon2);
export default __webpack_public_path__ + "static/media/amen-icon-2.034fa1eb54a42802028e6d85ef7f783f.svg";
export { ForwardRef as ReactComponent };